import { render, staticRenderFns } from "./followBrand_view.vue?vue&type=template&id=738cc29b&scoped=true&"
import script from "./followBrand_view.vue?vue&type=script&lang=js&"
export * from "./followBrand_view.vue?vue&type=script&lang=js&"
import style0 from "./followBrand_view.vue?vue&type=style&index=0&id=738cc29b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cc29b",
  null
  
)

export default component.exports